import _asyncToGenerator from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { normalizeProvider } from "@smithy/util-middleware";
import { AdaptiveRetryStrategy, DEFAULT_MAX_ATTEMPTS, DEFAULT_RETRY_MODE, RETRY_MODES, StandardRetryStrategy } from "@smithy/util-retry";
export var ENV_MAX_ATTEMPTS = "AWS_MAX_ATTEMPTS";
export var CONFIG_MAX_ATTEMPTS = "max_attempts";
export var NODE_MAX_ATTEMPT_CONFIG_OPTIONS = {
  environmentVariableSelector: function environmentVariableSelector(env) {
    var value = env[ENV_MAX_ATTEMPTS];
    if (!value) return undefined;
    var maxAttempt = parseInt(value);
    if (Number.isNaN(maxAttempt)) {
      throw new Error("Environment variable ".concat(ENV_MAX_ATTEMPTS, " mast be a number, got \"").concat(value, "\""));
    }
    return maxAttempt;
  },
  configFileSelector: function configFileSelector(profile) {
    var value = profile[CONFIG_MAX_ATTEMPTS];
    if (!value) return undefined;
    var maxAttempt = parseInt(value);
    if (Number.isNaN(maxAttempt)) {
      throw new Error("Shared config file entry ".concat(CONFIG_MAX_ATTEMPTS, " mast be a number, got \"").concat(value, "\""));
    }
    return maxAttempt;
  },
  default: DEFAULT_MAX_ATTEMPTS
};
export var resolveRetryConfig = function resolveRetryConfig(input) {
  var _input$maxAttempts;
  var _retryStrategy = input.retryStrategy;
  var maxAttempts = normalizeProvider((_input$maxAttempts = input.maxAttempts) !== null && _input$maxAttempts !== void 0 ? _input$maxAttempts : DEFAULT_MAX_ATTEMPTS);
  return _objectSpread(_objectSpread({}, input), {}, {
    maxAttempts: maxAttempts,
    retryStrategy: function () {
      var _retryStrategy2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var retryMode;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_retryStrategy) {
                  _context.next = 2;
                  break;
                }
                return _context.abrupt("return", _retryStrategy);
              case 2:
                _context.next = 4;
                return normalizeProvider(input.retryMode)();
              case 4:
                retryMode = _context.sent;
                if (!(retryMode === RETRY_MODES.ADAPTIVE)) {
                  _context.next = 7;
                  break;
                }
                return _context.abrupt("return", new AdaptiveRetryStrategy(maxAttempts));
              case 7:
                return _context.abrupt("return", new StandardRetryStrategy(maxAttempts));
              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      function retryStrategy() {
        return _retryStrategy2.apply(this, arguments);
      }
      return retryStrategy;
    }()
  });
};
export var ENV_RETRY_MODE = "AWS_RETRY_MODE";
export var CONFIG_RETRY_MODE = "retry_mode";
export var NODE_RETRY_MODE_CONFIG_OPTIONS = {
  environmentVariableSelector: function environmentVariableSelector(env) {
    return env[ENV_RETRY_MODE];
  },
  configFileSelector: function configFileSelector(profile) {
    return profile[CONFIG_RETRY_MODE];
  },
  default: DEFAULT_RETRY_MODE
};